// extracted by mini-css-extract-plugin
export default {"wrapper":"ProviderAccordionGroup_wrapper__1wB-x"};